<template>
  <div>
    <div
      class="fields-item"
      :class="{'hideFields': isHide}"
    >
      <div
        class="fields-item-tit"
        @click="showHide"
      >
        <span>{{ itemData.fieldname }}</span>
        <i class="iconfont iconicon-test19" />
        <i class="iconfont iconicon-test18" />
      </div>
      <div class="fields-item-con">
        <a-button
          v-for="child in itemData.child"
          :key="child.id"
          :disabled="child.checked"
          @click="addField(child)"
        >
          {{ child.fieldname }}
        </a-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: {
    itemData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      isHide: false
    }
  },
  computed: {
    ...mapState('universalForm/form', ['formDefaultDatas'])
  },
  methods: {
    showHide () {
      this.isHide = !this.isHide
    },
    addField (item) {
      let obj = {
        fieldkey: item.fieldkey,
        fieldtype: item.fieldtype,
        label: item.fieldname,
        isneeded: false,
        ishidden: false,
        placeholder: '',
        isActive: false,
        isdelete: true
      }
      const { fieldtype } = item
      // if (fieldtype === 'text' || fieldtype === 'number' || fieldtype === 'phone' || fieldtype === 'datetime' || fieldtype === 'email' || fieldtype === 'file') {
      //   obj= Object.assign(obj)
      // }
      if (fieldtype === 'checkbox' || fieldtype === 'radio') {
        item.options.forEach(item => {
          this.$set(item, 'isshow', true)
        })
        obj = Object.assign(obj, {
          options: item.options,
          defaultvalue: fieldtype === 'checkbox' ? [] : ''
        })
      } else if (fieldtype === 'editor') {
        obj = Object.assign(obj, {
          defaultvalue: ''
        })
      } else if (fieldtype === 'area') {
        delete obj.placeholder
        obj = Object.assign(obj, {
          defaultvalue: {},
          placeholder: {
            'select': '',
            'input': ''
          },
          fieldconfig: {
            enableforeign: 1,
            format: 1
          }
        })
      } else if (fieldtype === 'select_tree') {
        this.treeOptions(item.options)
        obj = Object.assign(obj, {
          defaultvalue: [],
          fieldconfig: {
          },
          options: item.options
        })
      } else if (fieldtype === 'select') {
        item.options.forEach(item => {
          this.$set(item, 'isshow', true)
        })
        obj = Object.assign(obj, {
          defaultvalue: '',
          fieldconfig: {
          },
          options: item.options
        })
      } else if (fieldtype === 'number') {
        obj = Object.assign(obj, {
          defaultvalue: '',
          fieldconfig: {
            isallowminus: 0, isallowdecimals: 0
          }
        })
      } else if (fieldtype === 'datetime') {
        obj = Object.assign(obj, {
          defaultvalue: '',
          fieldconfig: {
            isnow: true, formatdatetime: 1
          }
        })
      } else if (fieldtype === 'file') {
        obj = Object.assign(obj, {
          defaultvalue: '',
          fieldconfig: {
          }
        })
      } else {
        obj = Object.assign(obj, {
          defaultvalue: '',
          fieldconfig: {
          }
        })
      }
      if (!item.checked) {
        this.formDefaultDatas.push(obj)
        item.checked = true
        console.log(this.formDefaultDatas)
      }
    },
    treeOptions (arr) {
      arr.forEach(item => {
        // item['isshow'] = true
        this.$set(item, 'isshow', true)
        if (item.children) {
          this.treeOptions(item.children)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.fields-item {
  border-top: 1px solid #ebebeb;
  .fields-item-tit {
    height: 40px;
    line-height: 40px;
    background: #f5f6f7;
    position: relative;
    padding-left: 12px;
    span {
      color: #333;
    }
    .iconfont {
      position: absolute;
      right: 12px;
      font-size: 16px;
      color: #d8d8d8;
      cursor: pointer;
    }
  }
  .fields-item-con {
    padding: 16px 0;
    .ant-btn-default {
      background: #fff;
      margin-bottom: 10px;
    }
    button[disabled] {
      background: #f7f7f7;
    }
  }
  .iconicon-test19 {
    display: none;
  }
}
.hideFields {
  .iconicon-test19 {
    display: inline-block;
  }
  .iconicon-test18,
  .fields-item-con {
    display: none;
  }
}
</style>
